/**
 * 任务列表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>任务列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="任务ID :">
            <el-input
              size="small"
              v-model="formInline.taskId"
              placeholder="请输入任务ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="任务名称 :">
            <el-input
              size="small"
              v-model="formInline.taskName"
              placeholder="请输入任务名称"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="任务状态 :">
            <el-select
              size="small"
              v-model="formInline.status"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in status_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="发布时间: ">
            <el-date-picker
              size="small"
              v-model="formInline.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4"> </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="add_task"
        >发布任务</el-button
      >
      <el-button size="small" @click="exportData">导出数据</el-button>
      <el-button size="small" @click="onTaskMigration">任务导入</el-button>
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="taskName"
        label="任务名称"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taskId"
        label="任务ID"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taskTypeStr"
        label="任务类型"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.taskTypeStr }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="checkStatus"
        label="任务状态"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <span :style="{ color: getCheckStatusColor(scope.row.checkStatus) }">
            {{ getCheckStatusText(scope.row.checkStatus) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceCategoryDesc"
        label="开票类目"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column label="用工周期" show-overflow-tooltip min-width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.startTime }} - {{ scope.row.endTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="计费范围" show-overflow-tooltip min-width="150">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.minCharge &&
              scope.row.maxCharge &&
              scope.row.unitStr
                ? scope.row.minCharge +
                  " - " +
                  scope.row.maxCharge +
                  "元/" +
                  scope.row.unitStr
                : ""
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="年龄要求" show-overflow-tooltip min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.minAge }} - {{ scope.row.maxAge }}岁</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="location"
        label="服务地点"
        show-overflow-tooltip
        min-width="180"
      >
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="发布时间"
        show-overflow-tooltip
        min-width="160"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="上线状态"
        show-overflow-tooltip
        min-width="80"
      >
        <template slot-scope="scope">
          <el-switch
            :active-value="1"
            :inactive-value="0"
            v-model="scope.row.status"
            @change="changeStatus(scope.row.status, scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="registrationDtl"
        label="报名详情"
        show-overflow-tooltip
        min-width="80"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="viewRegistrationDtl(scope.row.taskId)"
            >查看</el-link
          >
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        min-width="340"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="small" plain>报名详情</el-button> -->
          <el-button
            type="primary"
            size="small"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="small"
            plain
            @click="openAssignFreelancerDialog(scope.row)"
            >分配</el-button
          >
          <el-button
            type="primary"
            size="small"
            plain
            @click="showShareDialog(scope.row)"
          >
            分享
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="form_dialog.title"
      :visible.sync="form_dialog.visible"
      width="80%"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="95px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
        label-position="left"
      >
        <div class="info-block">
          <p class="info-title"><span class="title">基本信息</span></p>
          <!--默认-->
          <div class="info-body">
            <el-row :gutter="30">
              <el-col :md="11" :xl="6">
                <el-form-item label="任务类型:" prop="taskType">
                  <el-select
                    size="small"
                    v-model="editForm.taskType"
                    placeholder="请选择"
                    filterable
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in tasktype_list"
                      :label="val.name"
                      :value="val.id"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="11" :xl="{ span: 6, offset: 1 }">
                <el-form-item label="任务名称:" prop="taskName">
                  <el-input
                    size="small"
                    style="width: 100%"
                    v-model="editForm.taskName"
                    auto-complete="off"
                    placeholder="请输入任务名称"
                  ></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="11" :xl="6">
                <el-form-item label="结算周期:" prop="settlementCycle">
                  <el-select
                    size="small"
                    v-model="editForm.settlementCycle"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in settlementCycle_list"
                      :label="val.label"
                      :value="val.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="11" :xl="{ span: 6, offset: 1 }">
                <el-form-item label="用工周期:" prop="date">
                  <el-date-picker
                    size="small"
                    v-model="editForm.date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="11" :xl="6">
                <el-form-item label="任务计费:" prop="minCharge">
                  <div style="display: flex; align-items: center; gap: 8px">
                    <el-input
                      size="small"
                      v-model="editForm.minCharge"
                      auto-complete="off"
                      placeholder="最低计费"
                      style="flex: 1"
                    ></el-input>
                    <span style="flex-shrink: 0">~</span>
                    <el-input
                      size="small"
                      v-model="editForm.maxCharge"
                      auto-complete="off"
                      placeholder="最高计费"
                      style="flex: 1"
                    ></el-input>
                    <span style="flex-shrink: 0">元 /</span>
                    <el-select
                      size="small"
                      v-model="editForm.unit"
                      placeholder="单位"
                      style="flex: 1"
                    >
                      <el-option
                        v-for="(val, index) in unit_list"
                        :label="val.label"
                        :value="val.value"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :md="11" :xl="{ span: 6, offset: 1 }">
                <el-form-item label="开票类目:" prop="invoiceCategory">
                  <el-cascader
                    size="small"
                    v-model="selectedCategories"
                    :options="categoriesOptions"
                    :props="{ expandTrigger: 'hover' }"
                    @change="handleInvoiceCategoryChange"
                    :show-all-levels="false"
                    placeholder="请选择开票类目"
                    filterable
                    style="width: 100%"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="info-block">
          <p class="info-title"><span class="title">任务要求</span></p>
          <!--默认-->
          <div class="info-body">
            <el-row :gutter="30">
              <el-col :md="11" :xl="6">
                <el-form-item label="性别要求:" prop="gender">
                  <el-select
                    size="small"
                    v-model="editForm.gender"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in gender_list"
                      :label="val.label"
                      :value="val.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="11" :xl="{ span: 6, offset: 1 }">
                <el-form-item label="学历要求:" prop="educationLevel">
                  <el-select
                    size="small"
                    v-model="editForm.educationLevel"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(val, index) in educationLevel_list"
                      :label="val.label"
                      :value="val.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :md="6" :xl="3">
                <el-form-item label="年龄要求:" prop="minAge">
                  <el-input
                    size="small"
                    v-model="editForm.minAge"
                    auto-complete="off"
                    placeholder="最小年龄"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="5" :xl="3">
                <el-form-item label=" ~" prop="maxAge" label-width="15px">
                  <el-input
                    size="small"
                    v-model="editForm.maxAge"
                    auto-complete="off"
                    placeholder="最大年龄"
                    style="width: 90%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="info-block">
          <p class="info-title"><span class="title">任务详情</span></p>
          <!--默认-->
          <div class="info-body">
            <el-row :gutter="30">
              <el-col :md="23" :xl="13">
                <el-form-item label="服务地点：" prop="locationVoList">
                  <el-select
                    size="small"
                    v-model="editForm.locationVoList[0].province"
                    placeholder="请选择"
                    @change="provinceChanged"
                    style="width: 31%"
                  >
                    <el-option
                      v-for="(val, index) in province_list"
                      :label="val.name"
                      :value="val"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    size="small"
                    v-model="editForm.locationVoList[0].city"
                    placeholder="请选择"
                    @change="cityChanged"
                    style="width: 31%"
                  >
                    <el-option
                      v-for="(val, index) in city_list"
                      :label="val.name"
                      :value="val"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    size="small"
                    v-model="editForm.locationVoList[0].district"
                    placeholder="请选择"
                    style="width: 31%"
                  >
                    <el-option
                      v-for="(val, index) in district_list"
                      :label="val.name"
                      :value="val.name"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="服务内容：" prop="content">
                  <el-input
                    type="textarea"
                    placeholder="请填写服务内容（10-1000字），例如：外卖配送员，公司配电动车，时间自由，全北京区域就近分配。"
                    v-model="editForm.content"
                    maxlength="1000"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="计费模式：" prop="billMode">
                  <el-input
                    type="textarea"
                    placeholder="请填写服务费计费模式（10-200字），例如：每单赚的8-20元，多劳多得（上不封顶），一天260-380元，服务费当日结。"
                    v-model="editForm.billMode"
                    maxlength="200"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="服务时间：" prop="serviceTime">
                  <el-input
                    type="textarea"
                    placeholder="请填写提供服务的时间（10-100字），例如：周一到周日，上午10:00-14:00 下午17:00-21:00，时间自由选择"
                    v-model="editForm.serviceTime"
                    maxlength="100"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :md="22" :xl="13">
                <el-form-item label="其他福利：" prop="otherBenefits">
                  <el-input
                    type="textarea"
                    placeholder="请填写可提供的其他福利（此处选填），例如：公司提供电动车，无需押金。可以享受高温补贴、高峰补贴、雨天补贴、恶略天气补贴，每单3-5元。"
                    v-model="editForm.otherBenefits"
                    maxlength="100"
                    show-word-limit
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-drawer
      :title="assignFreelancerDrawerTitle"
      :visible.sync="assignFreelancerDialogVisible"
      direction="rtl"
      size="980px"
      custom-class="assign-freelancer-drawer"
      @close="closeAssignFreelancerDialog"
    >
      <div class="assign-freelancer-drawer-inner">
        <div class="assign-freelancer-drawer-scroll">
          <el-form
            :inline="true"
            size="small"
            class="user-search assign-freelancer-search"
          >
            <el-form-item label="姓名">
              <el-input
                v-model="assignFreelancerSearch.name"
                placeholder="请输入姓名"
                clearable
                style="width: 140px"
                @keyup.enter.native="searchAssignFreelancers"
              ></el-input>
            </el-form-item>
            <el-form-item label="证件号">
              <el-input
                v-model="assignFreelancerSearch.idNumber"
                placeholder="请输入证件号"
                clearable
                style="width: 180px"
                @keyup.enter.native="searchAssignFreelancers"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchAssignFreelancers"
                >搜索</el-button
              >
              <el-button @click="resetAssignFreelancerSearch">清空</el-button>
            </el-form-item>
          </el-form>
          <div class="assign-freelancer-table-block">
            <el-table
            ref="assignFreelancerTable"
            :data="assignFreelancerTableList"
            v-loading="assignFreelancerLoading"
            size="small"
            :row-key="getAssignFreelancerRowKey"
            @selection-change="handleAssignFreelancerSelectionChange"
            style="width: 100%"
          >
            <el-table-column
              type="selection"
              width="48"
              :reserve-selection="true"
            ></el-table-column>
            <el-table-column
              prop="freelancerName"
              label="姓名"
              min-width="90"
              show-overflow-tooltip
            />
            <el-table-column
              prop="mobile"
              label="手机号"
              min-width="120"
              show-overflow-tooltip
            />
            <el-table-column
              prop="identityDocumentNumber"
              label="证件号"
              min-width="160"
              show-overflow-tooltip
            />
            <el-table-column
              prop="signStatusStr"
              label="签约状态"
              min-width="90"
              show-overflow-tooltip
            />
          </el-table>
          <Pagination
            class="assign-freelancer-pagination"
            v-bind:child-msg="assignFreelancerPageparm"
            @callFather="assignFreelancerPageChange"
          ></Pagination>
          </div>
        </div>
        <div class="assign-freelancer-drawer-footer">
          <div class="assign-freelancer-footer-left">
            <span class="assign-freelancer-footer-count">
              <template v-if="assignAllSelectedMode">
                已全选全部
              </template>
              <template v-else>
                已勾选 <b>{{ assignFreelancerIds.length }}</b> 人
              </template>
            </span>
            <el-button
              size="small"
              type="primary"
              :loading="assignSelectAllLoading"
              @click="selectAllAssignFreelancers"
              >全选</el-button
            >
            <el-button
              v-if="assignAllSelectedMode"
              size="small"
              @click="cancelAllAssignFreelancers"
              >取消全选</el-button
            >
          </div>
          <div class="assign-freelancer-footer-actions">
            <el-button size="small" @click="closeAssignFreelancerDialog"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="small"
              :loading="assignSubmitLoading"
              @click="submitAssignFreelancers"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      :visible.sync="shareDialogVisible"
      title="分享二维码"
      width="500px"
    >
      <div class="qrcode-container" v-if="qrcodeLoading">
        <i class="el-icon-loading"></i> 正在加载二维码...
      </div>

      <div class="qrcode-container" v-else-if="qrcodeUrl">
        <!-- 二维码图片 -->
        <img :src="qrcodeUrl" alt="二维码" />

        <!-- 任务名称 -->
        <div class="task-name">
          {{ this.qrTaskName }}
        </div>
      </div>

      <div class="qrcode-container" v-else>获取二维码失败，请稍后重试。</div>

      <template slot="footer">
        <span class="dialog-footer">
          <el-button v-if="qrcodeUrl" type="primary" @click="downloadQRCode">
            <i class="el-icon-download"></i> 保存二维码
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      :visible.sync="taskMigrationDialogVisible"
      title="任务导入"
      width="70%"
    >
      <el-table
        ref="multipleTable"
        size="small"
        :data="taskMigrationList"
        highlight-current-row
        v-loading="taskMigrationLoading"
        element-loading-text="拼命加载中"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="taskName" label="任务名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="taskId" label="任务ID" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="taskTypeStr"
          label="任务类型"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="distributeCompanyName"
          label="服务商"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="用工周期" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ellipsis-text">
              {{ scope.row.startTime }} - {{ scope.row.endTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="计费范围" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ellipsis-text">
              {{
                scope.row.minCharge &&
                scope.row.maxCharge &&
                scope.row.unitStr
                  ? scope.row.minCharge +
                    " - " +
                    scope.row.maxCharge +
                    "元/" +
                    scope.row.unitStr
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="年龄要求" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ellipsis-text">
              {{ scope.row.minAge }} - {{ scope.row.maxAge }}岁
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="location" label="服务地点" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="任务详情" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-popover placement="top" trigger="hover">
              <div style="white-space: pre-line">
                【服务内容】{{ scope.row.content || "" }} <br />
                【计费模式】{{ scope.row.billMode || "" }} <br />
                【服务时间】{{ scope.row.serviceTime || "" }} <br />
                【其他福利】{{ scope.row.otherBenefits || "" }}
              </div>
              <template #reference>
                <span style="cursor: pointer; color: #409eff">查看详情</span>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="发布时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="status" label="任务状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-switch
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.status"
              :disabled="true"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button size="small" @click="toggleSelection()">取消选择</el-button>
        <el-button size="small" type="primary" @click="handleTaskMigration()"
          >导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  deptList,
  editDeptList,
  getQrcodeUrl,
  editDeptListStatus,
  createDeptList,
  exportTask,
  gettasksTypes,
  getDisLimit,
  getAllAccountTasks,
  tasksMigration,
  getinvoiceCategory,
  assignFreelancersToTaskRegistration,
  getSignedNotRegisteredFreelancers,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import { china } from "../../common/area.js";
export default {
  data() {
    return {
      status_list: [
        {
          label: "上线",
          value: 1,
        },
        {
          label: "下线",
          value: 0,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      taskMigrationList: [],
      multipleSelectionTasks: [],
      taskMigrationLoading: false,
      taskMigrationDialogVisible: false,
      shareDialogVisible: false,
      qrcodeUrl: "",
      qrcodeLoading: false,
      qrTaskName: "",
      assignFreelancerDialogVisible: false,
      assignTaskRow: null,
      assignFreelancerIds: [],
      assignFreelancerTableList: [],
      assignFreelancerSearch: {
        name: "",
        idNumber: "",
      },
      assignFreelancerPage: 1,
      assignFreelancerPageSize: 10,
      assignFreelancerPageparm: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      assignFreelancerTotalCount: 0,
      assignFreelancerHasMore: true,
      assignFreelancerLoadingMore: false,
      assignFreelancerLoading: false,
      assignSubmitLoading: false,
      assignSelectAllLoading: false,
      // 全选模式：已拉取全部符合条件的数据 id，并允许用户在当前页取消勾选
      assignAllSelectedMode: false,
      assignAllFreelancerIds: [],
      assignDeselectedFreelancerIds: [],
      // 用于程序性 toggleSelection 时避免触发 selection-change 更新
      assignSelectionApplying: false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      form_dialog: {
        visible: false, //控制编辑页面显示与隐藏
        title: "新建任务",
      },
      editForm: {
        taskType: "",
        date: [],
        // taskId: '',
        taskName: "",
        settlementCycle: "",
        minCharge: "",
        maxCharge: "",
        unit: "",
        gender: "",
        educationLevel: "",
        minAge: "",
        maxAge: "",
        content: "",
        billMode: "",
        serviceTime: "",
        otherBenefits: "",
        locationVoList: [
          {
            province: "",
            city: "",
            district: "",
          },
        ],
        invoiceCategory: "",
      },
      tasktype_list: [],
      settlementCycle_list: [
        {
          label: "日结",
          value: 1,
        },
        {
          label: "周结",
          value: 2,
        },
        {
          label: "月结",
          value: 3,
        },
      ],
      unit_list: [
        {
          label: "日",
          value: 1,
        },
        {
          label: "月",
          value: 2,
        },
        {
          label: "小时",
          value: 3,
        },
        {
          label: "次",
          value: 4,
        },
        {
          label: "个",
          value: 5,
        },
        {
          label: "件",
          value: 6,
        },
      ],
      gender_list: [
        {
          label: "男女不限",
          value: 0,
        },
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      educationLevel_list: [
        {
          label: "学历不限",
          value: 1,
        },
        {
          label: "初中及以上",
          value: 2,
        },
        {
          label: "高中及以上",
          value: 3,
        },
        {
          label: "专科及以上",
          value: 4,
        },
        {
          label: "本科及以上",
          value: 5,
        },
        {
          label: "硕士及以上",
          value: 6,
        },
        {
          label: "博士",
          value: 7,
        },
      ],
      selectedCategories: [], // 用户选择的一级和二级类目
      categoriesOptions: [], // 开票类目级联选项
      province_list: [],
      city_list: [],
      district_list: [],
      disLimit: {
        maxAgeLimit: "",
        maxAmountLimit: "",
      },
      // rules表单验证 unit
      rules: {
        taskType: [
          { required: true, message: "请选择任务类型", trigger: "blur" },
        ],
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        settlementCycle: [
          { required: true, message: "请选择结算周期", trigger: "blur" },
        ],
        date: [{ required: true, message: "请选择用工周期", trigger: "blur" }],
        unit: [
          // { required: true, message: "请选择计费单位", trigger: "blur" },
          { validator: this.validateUnit, trigger: "blur" },
        ],
        gender: [
          { required: true, message: "请选择用工性别", trigger: "blur" },
        ],
        educationLevel: [
          { required: true, message: "请选择用工学历", trigger: "blur" },
        ],
        minCharge: [
          { required: true, message: "请输入最低计费", trigger: "blur" },
          { validator: this.validateMinCharge, trigger: "blur" },
        ],
        maxCharge: [
          // { required: true, message: "请输入最高计费", trigger: "blur" },
          { validator: this.validateMaxCharge, trigger: "blur" },
        ],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        minAge: [
          { required: true, message: "请输入最小年龄", trigger: "blur" },
          { validator: this.validateMinAge, trigger: "blur" },
        ],
        maxAge: [
          // { required: true, message: "请输入最大年龄", trigger: "blur" },
          { validator: this.validateMaxAge, trigger: "blur" },
        ],
        locationVoList: [
          { required: true, message: "请输入服务地点", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入服务内容", trigger: "blur" },
        ],
        billMode: [
          { required: true, message: "请输入计费模式", trigger: "blur" },
        ],
        serviceTime: [
          { required: true, message: "请输入服务时间", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        taskId: "",
        taskName: "",
        status: "",
        startDate: "",
        endDate: "",
        invoiceCategory: "",
        date: [],
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  computed: {
    assignFreelancerDrawerTitle() {
      const base = "分配";
      if (!this.assignTaskRow || !this.assignTaskRow.taskId) {
        return base;
      }
      const name = this.assignTaskRow.taskName || "";
      const id = this.assignTaskRow.taskId || "";
      return `${base} — ${name}（ID：${id}）`;
    },
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    this.province_list = [{ name: "不限", code: "", city: [] }];
    this.province_list = this.province_list.concat(china);
    // this.province_list = china;
    gettasksTypes().then((res) => {
      this.tasktype_list = res.data;
    });
    this.getInvoiceCategory();
    getDisLimit().then((res) => {
      if (res.msg == "success") {
        this.disLimit.maxAgeLimit = res.data.maxAgeLimit;
        this.disLimit.maxAmountLimit = res.data.maxAmountLimit;
      } else {
        this.$message({
          type: "error",
          message: res.msg,
        });
      }
    });
  },
  beforeDestroy() {
    this.unbindAssignTableScrollListener();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        taskId: "",
        taskName: "",
        status: "",
        startDate: "",
        endDate: "",
        date: [],
      };
      this.getdata(this.formInline);
    },
    //导出数据
    exportData() {
      let params = {
        page: 1,
        pageSize: 999999999,
        taskId: this.formInline.taskId,
        taskName: this.formInline.taskName,
        status: this.formInline.status,
        startDate: this.formInline.date[0] || "",
        endDate: this.formInline.date[1] || "",
        invoiceCategory: "",
      };

      exportTask(params)
        .then((res) => {
          window.open(res.data.downloadUrl);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getOtherAccountTasks() {
      this.taskMigrationLoading = true;
      getAllAccountTasks()
        .then((res) => {
          this.taskMigrationLoading = false;
          if (res.msg == "success") {
            this.taskMigrationList = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onTaskMigration() {
      this.taskMigrationList = [];
      this.getOtherAccountTasks();
      this.taskMigrationDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelectionTasks = val;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleTaskMigration() {
      if (
        !this.multipleSelectionTasks ||
        this.multipleSelectionTasks.length === 0
      ) {
        this.$message.error("请选择要导入的任务");
        return;
      }

      this.$confirm(
        "任务在导入不同服务商时，任务中最大年龄和最大下发金额会按该服务商默认配置。确定导入选中任务?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const taskIds = this.multipleSelectionTasks.map(
            (item) => item.taskId
          );
          tasksMigration(taskIds) // 传递选中的任务
            .then((res) => {
              if (res.msg === "success") {
                this.taskMigrationDialogVisible = false;
                this.getdata(this.formInline);
                this.$message.success("任务导入成功");
              } else {
                this.$message.error(res.msg || "导入失败，请重试");
              }
            })
            .catch((error) => {
              this.$message.error("网络错误，请稍后重试");
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    provinceChanged(val) {
      if (val.name === "不限") {
        this.editForm.locationVoList[0].province = "不限";
        this.editForm.locationVoList[0].city = "不限"; // 重置城市选择
        this.editForm.locationVoList[0].district = "不限"; // 重置区县选择
        this.city_list = [{ name: "不限", code: "", area: [] }];
      } else {
        this.editForm.locationVoList[0].city = "";
        this.editForm.locationVoList[0].district = "";
        this.city_list = val.city;
        this.editForm.locationVoList[0].province = val.name;
      }
    },
    cityChanged(val) {
      if (val.name === "不限") {
        this.editForm.locationVoList[0].district = "";
        this.district_list = [{ name: "不限", code: "" }];
        this.editForm.locationVoList[0].city = "不限";
      } else {
        this.editForm.locationVoList[0].district = "";
        this.district_list = val.area;
        this.editForm.locationVoList[0].city = val.name;
      }
    },
    add_task() {
      this.form_dialog.title = "新建任务";
      this.form_dialog.visible = true;
      this.selectedCategories = [];
      this.editForm = {
        taskType: "",
        date: [],
        // taskId: '',
        taskName: "",
        settlementCycle: "",
        minCharge: "",
        maxCharge: "",
        unit: "",
        gender: "",
        educationLevel: "",
        minAge: "",
        maxAge: "",
        content: "",
        billMode: "",
        serviceTime: "",
        otherBenefits: "",
        locationVoList: [
          {
            province: "",
            city: "",
            district: "",
          },
        ],
        invoiceCategory: "",
      };
    },
    changeStatus(val, row) {
      let parameter = {
        status: val == true ? 1 : 0,
      };
      editDeptListStatus(row.taskId, parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.getdata(this.formInline);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 获取公司列表
    getdata(parameter) {
      let params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
        taskId: this.formInline.taskId,
        taskName: this.formInline.taskName,
        status: this.formInline.status,
        startDate: this.formInline.date[0] || "",
        endDate: this.formInline.date[1] || "",
        invoiceCategory: "",
      };
      this.loading = true;
      deptList(params)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.listData = res.data.items;
            // this.listData.map(item => {
            //   if(item.recruitmentStateDesc == '上线'){
            //     item.status = true
            //   }else{
            //     item.status = false
            //   }
            // })
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    showShareDialog(row) {
      if (!row || !row.taskId) {
        console.error("任务信息不完整，无法获取二维码");
        this.$message.error("任务信息不完整，无法获取二维码");
        return;
      }
      this.shareDialogVisible = true;
      this.qrcodeLoading = true;
      getQrcodeUrl(row.taskId)
        .then((response) => {
          console.log(response);
          if (response.msg == "success") {
            this.qrcodeUrl = "data:image/png;base64," + response.data;
            this.qrTaskName = row.taskName;
          } else {
            this.$message.error("获取二维码失败，请稍后重试");
          }
        })
        .catch((error) => {
          console.error("获取二维码链接失败:", error);
          this.$message.error("获取二维码失败，请稍后重试");
          this.qrcodeUrl = "";
        })
        .finally(() => {
          this.qrcodeLoading = false;
          if (!this.qrcodeUrl) {
            this.shareDialogVisible = false;
          }
        });
    },

    downloadQRCode() {
      if (!this.qrcodeUrl) return;

      // 创建虚拟链接
      const link = document.createElement("a");
      link.href = this.qrcodeUrl;

      // 设置下载文件名（可根据需求动态生成）

      link.download = `【任务报名】扫码报名任务_${this.qrTaskName}.png`;

      // 触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 可选：添加下载成功提示
      this.$message.success("二维码已保存至本地");
    },
    viewRegistrationDtl(id) {
      this.$router.push({
        path: "/task/registrationDtl",
        query: {
          id: id,
        },
      });
    },
    openAssignFreelancerDialog(row) {
      if (!row || !row.taskId) {
        this.$message.error("任务信息不完整");
        return;
      }
      this.assignTaskRow = row;
      this.unbindAssignTableScrollListener();
      this.assignFreelancerIds = [];
      this.assignAllSelectedMode = false;
      this.assignAllFreelancerIds = [];
      this.assignDeselectedFreelancerIds = [];
      this.assignSelectionApplying = false;
      this.assignFreelancerTableList = [];
      this.assignFreelancerSearch = { name: "", idNumber: "" };
      this.assignFreelancerPage = 1;
      this.assignFreelancerPageSize = 10;
      this.assignFreelancerPageparm.page = 1;
      this.assignFreelancerPageparm.pageSize = 10;
      this.assignFreelancerPageparm.total = 0;
      this.assignFreelancerTotalCount = 0;
      this.assignFreelancerHasMore = true;
      this.assignFreelancerLoadingMore = false;
      this.assignFreelancerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.assignFreelancerTable) {
          this.$refs.assignFreelancerTable.clearSelection();
        }
      });
      this.fetchAssignFreelancerList(false, 1);
    },
    closeAssignFreelancerDialog() {
      this.unbindAssignTableScrollListener();
      this.assignFreelancerDialogVisible = false;
      this.assignTaskRow = null;
      this.assignFreelancerIds = [];
      this.assignAllSelectedMode = false;
      this.assignAllFreelancerIds = [];
      this.assignDeselectedFreelancerIds = [];
      this.assignSelectionApplying = false;
      this.assignFreelancerTableList = [];
      this.assignFreelancerSearch = { name: "", idNumber: "" };
      this.assignFreelancerLoading = false;
      this.assignFreelancerLoadingMore = false;
      this.assignSubmitLoading = false;
      this.assignFreelancerPage = 1;
      this.assignFreelancerPageSize = 10;
      if (this.assignFreelancerPageparm) {
        this.assignFreelancerPageparm.page = 1;
        this.assignFreelancerPageparm.pageSize = 10;
        this.assignFreelancerPageparm.total = 0;
      }
      this.$nextTick(() => {
        if (this.$refs.assignFreelancerTable) {
          this.$refs.assignFreelancerTable.clearSelection();
        }
      });
    },
    getAssignFreelancerRowKey(row) {
      if (!row || row.id == null || row.id === "") {
        return "";
      }
      return String(row.id);
    },
    handleAssignFreelancerSelectionChange(selection) {
      if (this.assignSelectionApplying) return;

      if (this.assignAllSelectedMode) {
        // isAll=true：由后端处理全量选择
        // 为避免“前端取消勾选”与后端结果不一致，这里强制恢复当前页全选状态
        this.assignDeselectedFreelancerIds = [];
        this.assignFreelancerIds = [];
        this.$nextTick(() => {
          this.applyAssignSelectionToCurrentPage();
        });
        return;
      }

      this.assignFreelancerIds = (selection || []).map((r) => r.id);
    },
    async selectAllAssignFreelancers() {
      if (!this.assignTaskRow || !this.assignTaskRow.taskId) {
        this.$message.error("任务信息不完整");
        return;
      }
      if (this.assignSelectAllLoading) return;

      this.assignSelectAllLoading = true;
      try {
        // 不再请求所有数据：只把“全选”意图交给后端
        this.assignAllSelectedMode = true;
        this.assignDeselectedFreelancerIds = [];
        this.assignFreelancerIds = [];

        this.$nextTick(() => {
          this.applyAssignSelectionToCurrentPage();
        });
      } catch (e) {
        this.$message.error((e && e.message) || "全选失败，请稍后重试");
      } finally {
        this.assignSelectAllLoading = false;
      }
    },
    // 取消全选：清空当前抽屉选中状态
    cancelAllAssignFreelancers() {
      this.assignAllSelectedMode = false;
      this.assignAllFreelancerIds = [];
      this.assignDeselectedFreelancerIds = [];
      this.assignFreelancerIds = [];

      this.assignSelectionApplying = true;
      this.$nextTick(() => {
        if (this.$refs.assignFreelancerTable) {
          this.$refs.assignFreelancerTable.clearSelection();
        }
        this.$nextTick(() => {
          this.assignSelectionApplying = false;
        });
      });
    },
    // 根据当前的 assignFreelancerIds 把当前页勾选状态同步到表格
    applyAssignSelectionToCurrentPage() {
      if (!this.$refs.assignFreelancerTable) return;

      this.assignSelectionApplying = true;
      this.$refs.assignFreelancerTable.clearSelection();

      const deselectSetStr = new Set(
        (this.assignDeselectedFreelancerIds || []).map((id) => String(id))
      );
      const selectedSetStr = new Set(
        (this.assignFreelancerIds || []).map((id) => String(id))
      );

      (this.assignFreelancerTableList || []).forEach((row) => {
        const id = row && row.id;
        if (id == null || id === "") return;
        const idStr = String(id);

        if (this.assignAllSelectedMode) {
          // 全选：当前页默认勾选，排除列表里的不勾
          if (!deselectSetStr.has(idStr)) {
            this.$refs.assignFreelancerTable.toggleRowSelection(row, true);
          }
        } else {
          // 非全选：只勾选已选 id 列表中的行
          if (selectedSetStr.has(idStr)) {
            this.$refs.assignFreelancerTable.toggleRowSelection(row, true);
          }
        }
      });

      this.$nextTick(() => {
        this.assignSelectionApplying = false;
      });
    },
    searchAssignFreelancers() {
      if (this.assignAllSelectedMode) {
        this.cancelAllAssignFreelancers();
      }
      this.assignFreelancerPage = 1;
      this.assignFreelancerHasMore = true;
      this.assignFreelancerPageparm.page = 1;
      this.fetchAssignFreelancerList(false, 1);
    },
    resetAssignFreelancerSearch() {
      if (this.assignAllSelectedMode) {
        this.cancelAllAssignFreelancers();
      }
      this.assignFreelancerSearch = { name: "", idNumber: "" };
      this.assignFreelancerPage = 1;
      this.assignFreelancerHasMore = true;
      this.assignFreelancerPageparm.page = 1;
      this.fetchAssignFreelancerList(false, 1);
    },
    assignFreelancerPageChange(parm) {
      this.assignFreelancerPage = parm.page;
      this.assignFreelancerPageSize = parm.pageSize;
      this.assignFreelancerPageparm.page = parm.page;
      this.assignFreelancerPageparm.pageSize = parm.pageSize;
      this.fetchAssignFreelancerList(false, parm.page);
    },
    loadMoreAssignFreelancers() {
      if (
        !this.assignFreelancerDialogVisible ||
        !this.assignFreelancerHasMore ||
        this.assignFreelancerLoading ||
        this.assignFreelancerLoadingMore
      ) {
        return;
      }
      this.fetchAssignFreelancerList(true);
    },
    bindAssignTableScrollListener() {
      this.unbindAssignTableScrollListener();
      this.$nextTick(() => {
        const table = this.$refs.assignFreelancerTable;
        if (!table || !table.bodyWrapper) return;
        this._assignScrollHandler = () => {
          const wrap = table.bodyWrapper;
          const { scrollTop, scrollHeight, clientHeight } = wrap;
          if (scrollHeight - scrollTop - clientHeight < 72) {
            this.loadMoreAssignFreelancers();
          }
        };
        table.bodyWrapper.addEventListener("scroll", this._assignScrollHandler);
      });
    },
    unbindAssignTableScrollListener() {
      const table = this.$refs.assignFreelancerTable;
      if (
        table &&
        table.bodyWrapper &&
        this._assignScrollHandler
      ) {
        table.bodyWrapper.removeEventListener(
          "scroll",
          this._assignScrollHandler
        );
      }
      this._assignScrollHandler = null;
    },
    fillAssignTableIfNeeded() {
      if (
        !this.assignFreelancerDialogVisible ||
        !this.assignFreelancerHasMore ||
        this.assignFreelancerLoading ||
        this.assignFreelancerLoadingMore
      ) {
        return;
      }
      this.$nextTick(() => {
        const table = this.$refs.assignFreelancerTable;
        if (!table || !table.bodyWrapper) return;
        const wrap = table.bodyWrapper;
        if (wrap.scrollHeight <= wrap.clientHeight + 2) {
          this.loadMoreAssignFreelancers();
        }
      });
    },
    fetchAssignFreelancerList(append, pageOverride) {
      const taskId = this.assignTaskRow && this.assignTaskRow.taskId;
      if (!taskId) {
        this.assignFreelancerLoading = false;
        this.assignFreelancerLoadingMore = false;
        if (!append) {
          this.assignFreelancerTableList = [];
        }
        return;
      }
      if (append) {
        if (
          !this.assignFreelancerHasMore ||
          this.assignFreelancerLoadingMore ||
          this.assignFreelancerLoading
        ) {
          return;
        }
        this.assignFreelancerLoadingMore = true;
      } else {
        if (this.assignFreelancerLoading) return;
        this.assignFreelancerLoading = true;
        this.assignFreelancerTableList = [];
      }
      const nextPage = append
        ? this.assignFreelancerPage + 1
        : pageOverride != null
          ? pageOverride
          : 1;
      const params = {
        page: nextPage,
        pageSize: this.assignFreelancerPageSize,
        name: this.assignFreelancerSearch.name || "",
        idNumber: this.assignFreelancerSearch.idNumber || "",
      };
      getSignedNotRegisteredFreelancers(taskId, params)
        .then((res) => {
          this.assignFreelancerLoading = false;
          this.assignFreelancerLoadingMore = false;
          if (res.msg === "success" && res.data) {
            const items = res.data.items || [];
            this.assignFreelancerTotalCount = res.data.totalCount || 0;
            this.assignFreelancerPage = res.data.page != null ? res.data.page : nextPage;
            this.assignFreelancerPageparm.total = this.assignFreelancerTotalCount;
            this.assignFreelancerPageparm.page = this.assignFreelancerPage;
            if (append) {
              const seen = new Set(
                this.assignFreelancerTableList.map((r) =>
                  this.getAssignFreelancerRowKey(r)
                )
              );
              items.forEach((row) => {
                const k = this.getAssignFreelancerRowKey(row);
                if (k && !seen.has(k)) {
                  seen.add(k);
                  this.assignFreelancerTableList.push(row);
                }
              });
            } else {
              this.assignFreelancerTableList = items;
            }
            if (append && items.length === 0) {
              this.assignFreelancerHasMore = false;
            } else {
              this.assignFreelancerHasMore =
                this.assignFreelancerTableList.length <
                this.assignFreelancerTotalCount;
            }
            // 分配改为分页展示时，禁止“向下滚动追加”监听
            this.$nextTick(() => {
              this.unbindAssignTableScrollListener();
              if (this.assignAllSelectedMode) {
                this.applyAssignSelectionToCurrentPage();
              }
            });
          } else {
            if (!append) {
              this.assignFreelancerTableList = [];
            }
            this.assignFreelancerHasMore = false;
            if (res.msg && res.msg !== "success") {
              this.$message({ type: "error", message: res.msg });
            }
          }
        })
        .catch(() => {
          this.assignFreelancerLoading = false;
          this.assignFreelancerLoadingMore = false;
          if (!append) {
            this.assignFreelancerTableList = [];
          }
        });
    },
    submitAssignFreelancers() {
      if (!this.assignTaskRow || !this.assignTaskRow.taskId) {
        this.$message.error("任务信息不完整");
        return;
      }

      this.assignSubmitLoading = true;

      const params = this.assignAllSelectedMode
        ? {
            isAll: true,
          }
        : {
            isAll: false,
            ids: this.assignFreelancerIds.slice(),
          };

      assignFreelancersToTaskRegistration(this.assignTaskRow.taskId, params)
        .then((res) => {
          this.assignSubmitLoading = false;
          if (res.msg === "success") {
            this.$message.success("分配成功，对方已计入任务报名");
            this.closeAssignFreelancerDialog();
          } else {
            this.$message({ type: "error", message: res.msg || "分配失败" });
          }
        })
        .catch(() => {
          this.assignSubmitLoading = false;
        });
    },
    //显示编辑界面
    handleEdit(row) {
      console.log(row);
      this.form_dialog.title = "编辑任务";
      this.editForm = row;
      this.editForm.date = [row.startTime, row.endTime];
      this.editForm.locationVoList = [
        {
          province: "",
          city: "",
          district: "",
        },
      ];
      this.editForm.locationVoList[0].province = row.location.split("-")[0];
      this.editForm.locationVoList[0].city = row.location.split("-")[1];
      this.editForm.locationVoList[0].district = row.location.split("-")[2];

      this.editForm = JSON.parse(JSON.stringify(this.editForm));
      // 初始化开票类目选择（如果有值，需要找到对应的父级和子级）
      if (row.invoiceCategory) {
        this.initSelectedCategories(row.invoiceCategory);
      } else {
        this.selectedCategories = [];
      }
      this.form_dialog.visible = true;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          let params = {
            taskType: this.editForm.taskType, // 任务类型
            taskName: this.editForm.taskName, // 任务名称
            settlementCycle: this.editForm.settlementCycle, // 结算周期
            startTime: this.editForm.date[0], // 用工周期-开始日期
            endTime: this.editForm.date[1], // 用工周期-结束日期
            minCharge: this.editForm.minCharge, // 任务计费-最低计费
            maxCharge: this.editForm.maxCharge, // 任务计费-最高计费
            unit: this.editForm.unit, // 单位
            gender: this.editForm.gender, // 性别要求
            educationLevel: this.editForm.educationLevel, // 学历要求
            minAge: this.editForm.minAge, // 年龄要求-最小年龄
            maxAge: this.editForm.maxAge, // 年龄要求-最高要求
            locationVoList: this.editForm.locationVoList, // 服务地点
            content: this.editForm.content, // 服务内容
            billMode: this.editForm.billMode, // 计费模式
            serviceTime: this.editForm.serviceTime, // 服务时间
            otherBenefits: this.editForm.otherBenefits, // 其它福利
            invoiceCategory: this.editForm.invoiceCategory, // 开票类目
          };
          if (this.form_dialog.title == "编辑任务") {
            editDeptList(this.editForm.taskId, params)
              .then((res) => {
                this.loading = false;
                console.log(res);
                if (res.msg == "success") {
                  this.form_dialog.visible = false;
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "编辑成功！",
                  });
                } else {
                  this.form_dialog.visible = true;
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.form_dialog.visible = false;
                this.loading = false;
                this.$message.error("操作失败，请稍后再试！");
              });
          } else {
            createDeptList(params)
              .then((res) => {
                this.loading = false;
                console.log(res);
                if (res.msg == "success") {
                  this.form_dialog.visible = false;
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "创建成功！",
                  });
                } else {
                  this.form_dialog.visible = true;
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.form_dialog.visible = false;
                this.loading = false;
                this.$message.error("操作失败，请稍后再试！");
              });
          }
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let parameter = {
            status: 2,
          };
          editDeptListStatus(row.taskId, parameter)
            .then((res) => {
              this.loading = false;
              if (res.msg == "success") {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败！");
            });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "已取消删除",
          });
        });
    },
    getDisLimit() {},
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.form_dialog.visible = false;
      this.selectedCategories = [];
    },
    // 获取开票类目
    getInvoiceCategory() {
      getinvoiceCategory()
        .then((res) => {
          if (res.msg !== "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
            return;
          }
          if (res.data.length == 0) {
            this.$message({
              type: "error",
              message: "开票类目未配置，请联系管理员配置",
            });
            return;
          }
          this.categoriesOptions = res.data;
        })
        .catch((err) => {
          this.$message.error("获取开票类目失败");
        });
    },
    // 处理开票类目选择变化
    handleInvoiceCategoryChange(value) {
      if (value && value.length === 2) {
        this.editForm.invoiceCategory = value[1];
      } else {
        this.editForm.invoiceCategory = "";
      }
    },
    // 初始化选中的开票类目（根据 invoiceCategory 值查找对应的父级和子级）
    initSelectedCategories(invoiceCategory) {
      if (!invoiceCategory || !this.categoriesOptions.length) {
        this.selectedCategories = [];
        return;
      }
      // 遍历 categoriesOptions 查找匹配的二级类目
      for (let parent of this.categoriesOptions) {
        if (parent.children && parent.children.length > 0) {
          for (let child of parent.children) {
            if (child.value === invoiceCategory) {
              this.selectedCategories = [parent.value, child.value];
              return;
            }
          }
        }
      }
      this.selectedCategories = [];
    },
    validateUnit(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请选择计费单位"));
      }

      callback();
    },

    validateMinCharge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最低计费"));
      }

      // 默认最大98000
      if (
        this.disLimit.maxAmountLimit === "" ||
        this.disLimit.maxAmountLimit === 0 ||
        this.disLimit.maxAmountLimit === null
      ) {
        this.disLimit.maxAmountLimit = 98000;
      }

      const charge = parseInt(value, 10);
      if (isNaN(charge)) {
        callback(new Error("请输入有效的数字"));
      } else if (charge < 1 || charge > this.disLimit.maxAmountLimit) {
        callback(
          new Error(`最低计费必须大于1小于${this.disLimit.maxAmountLimit}元`)
        );
      } else {
        callback();
      }
    },
    validateMaxCharge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最高计费"));
      }

      // 默认最大98000
      if (
        this.disLimit.maxAmountLimit === "" ||
        this.disLimit.maxAmountLimit === 0 ||
        this.disLimit.maxAmountLimit === null
      ) {
        this.disLimit.maxAmountLimit = 98000;
      }

      const minCharge = parseFloat(this.editForm.minCharge);
      const charge = parseInt(value, 10);

      if (!minCharge) {
        return callback(new Error("请先输入最低计费"));
      }
      if (charge <= minCharge) {
        return callback(new Error("最高计费必须大于最低计费"));
      }
      if (isNaN(charge)) {
        callback(new Error("请输入有效的数字"));
      } else if (charge > this.disLimit.maxAmountLimit || charge < 1) {
        callback(
          new Error(`最高计费必须小于${this.disLimit.maxAmountLimit}大于1元`)
        );
      } else {
        callback();
      }
    },
    validateMinAge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最小年龄"));
      }
      // 默认最大65
      if (
        this.disLimit.maxAgeLimit === "" ||
        this.disLimit.maxAgeLimit === 0 ||
        this.disLimit.maxAgeLimit === null
      ) {
        this.disLimit.maxAgeLimit = 65;
      }
      const age = parseInt(value, 10);
      if (isNaN(age)) {
        callback(new Error("请输入有效的数字"));
      } else if (age < 18 || age > this.disLimit.maxAgeLimit) {
        callback(
          new Error(
            `最小年龄必须大于等于18岁小于等于${this.disLimit.maxAgeLimit}岁`
          )
        );
      } else {
        callback();
      }
    },
    validateMaxAge(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入最大年龄"));
      }

      // 默认最大65
      if (
        this.disLimit.maxAgeLimit === "" ||
        this.disLimit.maxAgeLimit === 0 ||
        this.disLimit.maxAgeLimit === null
      ) {
        this.disLimit.maxAgeLimit = 65;
      }

      const minAge = parseInt(this.editForm.minAge);
      const age = parseInt(value, 10);

      if (!minAge) {
        return callback(new Error("请先输入最低年龄"));
      }

      if (age <= minAge) {
        return callback(new Error("最大年龄必须大于最低年龄"));
      }

      if (isNaN(age)) {
        callback(new Error("请输入有效的数字"));
      } else if (age > this.disLimit.maxAgeLimit || age < 18) {
        callback(
          new Error(
            `最小年龄必须大于等于18岁小于等于${this.disLimit.maxAgeLimit}岁`
          )
        );
      } else {
        callback();
      }
    },
    // 获取审核状态文字
    getCheckStatusText(checkStatus) {
      const statusMap = {
        0: "待审核",
        1: "审核中",
        2: "进行中",
        3: "驳回",
      };
      return statusMap[checkStatus] !== undefined
        ? statusMap[checkStatus]
        : "未知";
    },
    // 获取审核状态颜色
    getCheckStatusColor(checkStatus) {
      const colorMap = {
        0: "#909399", // 待审核 - 灰色
        1: "#409EFF", // 审核中 - 蓝色
        2: "#67C23A", // 进行中 - 绿色
        3: "#F56C6C", // 驳回 - 红色
      };
      return colorMap[checkStatus] !== undefined ? colorMap[checkStatus] : "#909399";
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.info-block {
  background: #fff;
  border: 1px solid #e5e5e5;
  margin-bottom: 20px;
}
.info-block .info-title {
  background-color: #f0f2f5;
  margin: 0 !important;
  font-size: 16px;
  padding: 0 32px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
}
.info-block .info-body {
  padding: 24px 32px;
}
.blockTitle span:nth-child(2) {
  font-size: 18px;
  color: #272727;
  margin-top: 10px;
  font-weight: 700;
}
.blockTitleOrage span:nth-child(2) {
  color: #ff943e;
  font-weight: 700;
  font-size: 20px;
  margin-top: 10px;
}

.qrcode-container {
  text-align: center;
  padding: 15px 0;
}

/* 二维码图片样式 */
.qrcode-container img {
  width: 250px;
  height: 250px;
  display: block;
  margin: 0 auto;
}

/* 任务名称样式 */
.task-name {
  font-size: 16px;
  color: #333;
  font-weight: 400;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  word-break: break-word;
}

.ellipsis-text {
  white-space: nowrap; /* 强制不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 继承父容器宽度，确保以列宽为基准截断 */
}

.assign-freelancer-drawer-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}
.assign-freelancer-drawer-scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.assign-freelancer-table-block {
  flex: 0 0 auto;
  width: 100%;
}

.assign-freelancer-select-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 8px;
}
::v-deep .assign-freelancer-pagination.page-box {
  margin: 4px 0 0;
}
.assign-freelancer-search {
  margin-bottom: 8px;
}
.assign-freelancer-load-tip {
  text-align: center;
  padding: 6px 0 2px;
  color: #c0c4cc;
  min-height: 0;
}
.assign-freelancer-load-tip .el-icon-loading {
  font-size: 16px;
}
.assign-freelancer-drawer-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 4px 18px;
  margin-top: 4px;
  border-top: 1px solid #ebeef5;
  box-sizing: border-box;
}
.assign-freelancer-footer-count {
  font-size: 13px;
  color: #606266;
  flex-shrink: 0;
}
.assign-freelancer-footer-count b {
  color: #409eff;
  font-weight: 600;
}
.assign-freelancer-footer-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.assign-freelancer-footer-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

::v-deep .assign-freelancer-drawer .el-drawer__header {
  align-items: flex-start;
  margin-bottom: 16px;
}
::v-deep .assign-freelancer-drawer .el-drawer__header > span[role="heading"],
::v-deep .assign-freelancer-drawer .el-drawer__header span[title] {
  white-space: normal;
  line-height: 1.45;
  padding-right: 36px;
  word-break: break-word;
}
::v-deep .assign-freelancer-drawer .el-drawer__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 20px 8px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/task/taskList.vue